export const ADD_BOOCH = 'ADD_BOOCH';
export const DELETE_BOOCH = 'DELETE_BOOCH';
export const TOGGLE_FORM = 'TOGGLE_FORM';
export const MAKE_NULL = 'MAKE_NULL';
export const SELECT_BOOCH = 'SELECT_BOOCH';
export const SET_EDIT = 'SET_EDIT';